import preset from '@/@core/preset/preset'
import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import fr from 'vuetify/src/locale/fr.ts'
Vue.use(Vuetify)

export default new Vuetify({
  preset,
  icons: {
    iconfont: 'mdiSvg',
  },
  lang: {
    locales: { fr },
    current: 'fr',
  },
  theme: {
    options: {
      customProperties: true,
      variations: false,
    },
  },
})
